module.exports = __webpack_public_path__ + "7da0f95ac52879be227912e4c1d80979.jpg";